import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const ContainsMatcher: FieldMatcher = {
  name: 'contains',
  displayName: 'Contains',
  hasEditor: true,
  options: {
    chipFormatter: (value: string) => `: ${value}`,
  },
};